import { useState, useEffect, useCallback, useRef } from "react";
import { FaSearch } from "react-icons/fa";
import Modal from "./Modal";
import { IoMdAdd } from "react-icons/io";
import "./user.css";
import "./UserManagement.css";
import { toast } from "react-toastify";
import KeyModal from "./KeyModal";
import UserManageTable from "./UserManageTable.jsx";
import Spinner from "../Spin/Spinner.jsx";
import TableExportButton from "./TableExportButton";
import { IoReload } from "react-icons/io5";
import {
  getAllUsers,
  getMerchantUsers,
  createUser,
  createMerchantUser,
} from "../../config/LiveApi";
import { useSelector } from "react-redux";

const UserManagement = () => {
  const searchInputRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isKeyModalOpen, setIsKeyModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  let [page, setPage] = useState(1);
  const [pageData, setPageData] = useState(null);
  const [numberPages, setNumberPages] = useState(1);
  const [key, setKey] = useState("");
  const initialFormData = {
    name: "",
    password: "",
    alias: "",
    email: "",
    role: "",
    providerPayinComission: "0",
    providerPayoutComission: "0",
    adminPayinComission: "0",
    adminPayoutComission: "0",
    rollingReserve: "0",
    totalPayinComission: "0",
    totalPayoutComission: "0",
    rollingReserveDays: "90",
    minPayinAmount: "0",
    maxPayinAmount: "0",
    minPayoutAmount: "0",
    maxPayoutAmount: "0",
    api_version: 1,
    penaltyAmount: "2000",
  };
  const [payinChecked, setPayinChecked] = useState(true);
  const [payoutChecked, setPayoutChecked] = useState(true);
  const [tableData, setTableData] = useState([]);
  const role = useSelector((store) => store.userReducer.role);
  const token = useSelector((store) => store.userReducer.token);
  const [originalTableData, setOriginalTableData] = useState([]);

  const fetchUsers = async (page) => {
    setIsLoading(true);
    try {
      if (page === undefined) page = 1;
      let response;
      if (role === "super" || role === "operation" || role === "subSuper") {
        response = await getAllUsers(token, page);
      } else if (role === "admin" || role === "subAdmin")
        response = await getMerchantUsers(token, page);

      const data = response?.data;
      const paginationData = response?.meta;
      setOriginalTableData(data);
      setTableData(data);
      setPageData(paginationData);
      setPage(paginationData?.pagination?.page);

      const hasStatusOneOrThree = data.some(
        (item) => item.status === 3 || item.status === 1,
      );
      const hasStatusOneOrTwo = data.some(
        (item) => item.status === 1 || item.status === 2,
      );

      if (!hasStatusOneOrThree) setPayinChecked(false);
      if (!hasStatusOneOrTwo) setPayoutChecked(false);

      setNumberPages(paginationData?.pagination?.totalPages);
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers(page);
  }, [page]);

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const handleKeyModalClose = () => {
    setIsKeyModalOpen(false);
  };

  const handleSubmit = async (submittedFormData) => {
    setIsLoading(true);

    try {
      let response;
      const payload = { ...submittedFormData };

      if (role === "super") {
        response = await createUser(payload, token);
      } else if (role === "operation") {
        payload.role = "admin";
        response = await createUser(payload, token);
      } else if (role === "admin") {
        response = await createMerchantUser(payload, token);
      }

      const newUser = response?.user;

      if (newUser) {
        newUser.dialogOpen = false;

        setTableData((prev) => [...prev, newUser]);
      }

      toast.success("Successfully added new user.");

      if (newUser?.apiKey) {
        setKey({
          apiKey: newUser.apiKey,
          aesKey: newUser.aesKey || "",
        });

        if (newUser.role === "admin") {
          setIsKeyModalOpen(true);
        }
      }

      setIsModalOpen(false);

      fetchUsers(page);
    } catch (error) {
      toast.error("User cannot be added. Please enter the details correctly.");
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const reloadfunction = () => {
    window.location.reload();
  };

  const handleSearch = () => {
    const query = searchInputRef.current?.value?.trim().toLowerCase() || "";
    if (!query) {
      setTableData(originalTableData);
      return;
    }

    const filteredData = originalTableData.filter((user) => {
      const alias = user.alias ? user.alias.toLowerCase().trim() : "";
      const name = user.name ? user.name.toLowerCase().trim() : "";

      if (alias) {
        return alias.includes(query);
      }
      if (name) {
        return name.includes(query);
      }
      return false;
    });
    setTableData(filteredData);
  };

  return (
    <div className="content-area">
      <div className="manage-header">
        <h2 className="area-top-title">User Management</h2>
      </div>

      <div className="user-sub-head">
        <div className="search-divs">
          <div className="search">
            <input
              type="text"
              className="search-input-user"
              placeholder="Search User By Name"
              style={{ height: "40px" }}
              ref={searchInputRef}
            />
            <FaSearch className="search-icon-user" />
            <button
              className="go-btn"
              style={{ margin: "10px", height: "40px" }}
              onClick={handleSearch}
            >
              Go
            </button>
            <button
              className="reload-btn"
              onClick={() => reloadfunction()}
              style={{ margin: "10px", height: "40px" }}
            >
              <IoReload />
            </button>
          </div>
        </div>
        <div className="big-visi-sec">
          <div className="big-visi">
            <button
              className="addUser-btnn"
              onClick={() => setIsModalOpen(true)}
            >
              <IoMdAdd
                style={{
                  width: "1.2rem",
                  height: "1.2rem",
                }}
              />
              Add User
            </button>
          </div>
          <TableExportButton tableData={tableData} filename="table.xlsx" />
        </div>
      </div>
      <div>
        {isModalOpen && (
          <Modal
            onClose={handleModalClose}
            onSubmit={handleSubmit}
            initialFormData={initialFormData}
            isUpdating={false}
            isLoading={isLoading}
            role={role}
          />
        )}

        {isKeyModalOpen && (
          <KeyModal onClose={handleKeyModalClose} data={key} />
        )}
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <UserManageTable
          isLoading={isLoading}
          tableData={tableData}
          setTableData={setTableData}
          onUpdateTableData={setTableData}
          fetchUsers={fetchUsers}
          payinChecked={payinChecked}
          payoutChecked={payoutChecked}
          setPayinChecked={setPayinChecked}
          setPayoutChecked={setPayoutChecked}
        />
      )}
    </div>
  );
};

export default UserManagement;
